<!-- Solo mostrar el spinner hasta que todo esté cargado -->
<ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default" color="var(--primary-color)"
  type="ball-atom" [fullScreen]="true">
</ngx-spinner>

<div *ngIf="isFullyLoaded">
  <!-- Aquí va todo tu contenido actual del HTML -->
   <mat-card appearance="outlined">
      <mat-card-header>
        <div class="header-nombre-nuevo">
          <h2>{{titulo}}</h2>
          <app-button-new matTooltip="Nuevo registro" (click)="agregar()"
            *appRoles="[nombreEntidadTabla+'.Crear']"></app-button-new>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="row align-items-center">
          <div class="col-auto">

            <div style="display: flex; align-items: center; gap: 8px;">
              <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
              <app-button-filter-table-clear></app-button-filter-table-clear>
            </div>
          </div>
          <!-- <div class="col-auto">
        <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
          Filtros Avanzados
        </mat-slide-toggle>
      </div> -->
        </div>
      </mat-card-content>
      <mat-card-content>
        <mat-divider></mat-divider>
        <!-- Inicio Contenedor acciones tabla -->
        <div class="contenedor-acciones-tablas">
          <div class="acciones-tabla">
            <!-- Boton de Acciones -->
            <!-- <app-button-action></app-button-action> -->
          </div>
          <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
          </mat-form-field>
        </div>
        <!-- Fin Contenedor acciones tabla -->

        <table mat-table [dataSource]="dataSource" *ngIf="dataSource && dataSource.data.length > 0" matSort
          class="mat-elevation-z8">

          <ng-container matColumnDef="descripcion">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Descripción</strong>
            </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let item">
              <span>{{ item.descripcion | titlecase }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="observaciones">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Observaciones</strong>
            </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let item">
              <span>{{ item.observaciones }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="accion">
            <mat-header-cell mat-header-cell *matHeaderCellDef>
              <strong>Acción</strong>
            </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let item" class="action-link">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="ver(item)" *appRoles="[nombreEntidadTabla+'.Ver']">
                  <mat-icon>visibility</mat-icon>
                  <span>Ver</span>
                </button>
                <button mat-menu-item (click)="editar(item)" *appRoles="[nombreEntidadTabla+'.Modificar']">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="eliminar(item)" *appRoles="[nombreEntidadTabla+'.Eliminar']">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <div *ngIf="dataSource.data.length > 0">
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          </div>
          <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
        </table>

        <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

        <mat-paginator showFirstLastButtons class="paginator" *ngIf="dataSource.data.length > 0" [pageSize]="20"
          [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
        </mat-paginator>

      </mat-card-content>
    </mat-card>
</div>
